export { default } from './SuppressedCountTabBadge';
